$(function () {
	$(".masked").each(function () {
		SetupMaskedInput($(this));
	});

	$(document).on("click", ".masked-toggle", function (e) {
		var element = $(e.target);
		if (!element.is('[href]'))
			element = element.closest('[href]'); //catch bubbles
		if (element.hasClass("on"))
			element.next(".masked").unmask();
		else
			SetMask(element.next(".masked"));
		element.toggleClass("on");
		element.html(GetMaskToggleText(!element.hasClass("on")));
		element.attr("aria-label", "Phone format is " + GetMaskToggleText(!element.hasClass("on")))

		var $saveDiv = element.closest('.for-phone');   
		var $hiddenIntl = $saveDiv.find('[id*="IsInternational"]');
		$hiddenIntl.val(!element.hasClass("on")?'True':'False').trigger('change');
	});
});

function IsInternational(input) {
	if (input.val() == "")
		return false;
	if (input.hasClass("phone"))
		return !(new RegExp("^\\(\\d{3}\\)\\d{3}-\\d{4}" + (input.data("phone-extension") ? "( x[\\s]?\\d{1,7})?" : "") + "$").test(input.val()));
}

function GetMaskToggleText(isInternational) {
	return isInternational ? "USA/Canada?" : "International?";
}

function SetMask(input) {
	if (input.hasClass("phone")) {
		input.mask("(999)999-9999" + (input.data("phone-extension") ? "? x9999999" : "")).blur(function () { $(this).valid(); });

		if (input.data("phone-extension")) {
			input.bind('input', function (e) {
				setTimeout(function () {
					var curVal = input.val();
					if (curVal && curVal.indexOf('_', curVal.length - 1) !== -1) {
						input.blur();
					}
				}, 20);
			});
		}
	}

	input.bind('paste', function (e) {
		var pastedText = '';

		if (window.clipboardData && window.clipboardData.getData) { // IE
			pastedText = window.clipboardData.getData('Text');
		}
		else if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) { // other browsers
			pastedText = e.originalEvent.clipboardData.getData('text/plain');
		}

		input.val(pastedText);
		e.preventDefault();
		return;
	});
}

function SetupMaskedInput(input) {
	var $hidden = input.closest('.for-phone')
		.find('[id*="IsInternational"]')
	var isInternational = false;

	console.log(input);
	if ($hidden) {
		console.log($hidden.val());
		isInternational = ($hidden.val() && $hidden.val().toString().toLowerCase() === "true");
	} else {
		isInternational = IsInternational(input);          // original fallback
	}

	if (!isInternational)
		SetMask(input);
	if (input.hasClass("phone") && input.prev(".masked-toggle").length == 0)
		input.before('<a class="masked-toggle' + (isInternational ? "" : " on") + '" href="javascript:void(0);" aria-live="polite" aria-label="Phone format is ' + GetMaskToggleText(isInternational) + '">' + GetMaskToggleText(isInternational) + '</a>');
}